export default "__VITE_ASSET__gzvESt$p__"